import { motion } from 'framer-motion';
import { useState } from 'react';
import { PiCaretDownBold, PiCaretUpBold, PiMapTrifold } from 'react-icons/pi';
interface RouteMapProps {
  googleMapsEmbedUrl?: string | null;
}

export const RouteMap = ({ googleMapsEmbedUrl }: RouteMapProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!googleMapsEmbedUrl) return null;

  return (
    <div className="flex flex-col">
      <button
        className="ml-auto flex items-center gap-1 px-1 py-1 text-gray-500 hover:text-gray-700"
        onClick={() => setIsExpanded((prev) => !prev)}
        type="button"
      >
        <PiMapTrifold className="h-3.5 w-3.5" />
        <span className="text-xs">Map</span>
        {isExpanded ? (
          <PiCaretUpBold className="h-3.5 w-3.5" />
        ) : (
          <PiCaretDownBold className="h-3.5 w-3.5" />
        )}
      </button>
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: isExpanded ? 280 : 0 }}
        transition={{ duration: 0.25 }}
        className="overflow-hidden"
      >
        {isExpanded && (
          <iframe
            title="Route Map"
            src={googleMapsEmbedUrl}
            width="100%"
            height="280"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        )}
      </motion.div>
    </div>
  );
};
